// client\src\services\myLearningService.js
import apiClient from '../utils/apiClient';

export const getOngoingCourses = async () => {
    try {
        const response = await apiClient.get(`/mylearning/ongoing`);
        return response.data;
    } catch (error) {
        console.error("Error fetching ongoing courses:", error);
        return { success: false, message: "Failed to fetch ongoing courses", data: null };
    }
};

export const getCompletedCourses = async () => {
    try {
        const response = await apiClient.get(`/mylearning/completed`);
        return response.data;
    } catch (error) {
        console.error("Error fetching completed courses:", error);
        return { success: false, message: "Failed to fetch completed courses", data: null };
    }
};
